// Pure positioning math for the gantt timeline, extracted so it can be unit
// tested without importing the (heavy) component module.

export interface GanttOffsetContext {
  columnWidth: number
  zoom: number
  columnDurationMinutes: number
}

// Fractional minutes between two dates. Unlike date-fns' differenceInMinutes
// (which truncates to whole minutes and drops seconds), this stays continuous so
// a feature's offset and width remain additive: offset(end) === offset(start) +
// width(start, end). Truncating each independently would otherwise make a bar's
// right edge land up to a minute short of the next bar's left edge, drawing a
// phantom gap between activities that actually touch (visible once activities
// carry second-precision timestamps, e.g. telematics estimates).
export const diffInMinutesPrecise = (laterDate: Date, earlierDate: Date) =>
  (laterDate.getTime() - earlierDate.getTime()) / 60000

export const getOffset = (
  date: Date,
  timelineStartDate: Date,
  context: GanttOffsetContext
) => {
  const parsedColumnWidth = (context.columnWidth * context.zoom) / 2400
  const diffInMinutes = diffInMinutesPrecise(date, timelineStartDate)
  return parsedColumnWidth * (diffInMinutes / context.columnDurationMinutes)
}

export const getWidth = (
  startAt: Date,
  endAt: Date,
  context: GanttOffsetContext
) => {
  const parsedColumnWidth = (context.columnWidth * context.zoom) / 2400
  const diffInMinutes = diffInMinutesPrecise(endAt, startAt)
  return parsedColumnWidth * (diffInMinutes / context.columnDurationMinutes)
}
